import * as THREE from 'three';

// Loads the sea of clouds tools/build-cloudsea.mjs prepared - the dawn and the
// sunrise (aligned), their cloud plates, the lossless masks (R sky, G peaks,
// B foreground; the clouds are the rest) and the flow field (RG vector, B the
// veils' pull) - once, at startup, for visualizers/cloudsea.js. Same
// preload/get shape as moonlake-assets.js, and the same rule: the preload is
// a WIRING POINT every entry point must call (main, main-radio,
// main-embedded, play-boot, player-boot, landing-boot, demo-boot, the capture
// harness). The sunrise is optional (the scene then stays at dawn, R11
// fallback); without the dawn, the masks or the flow it resolves to null and
// the entry points withdraw Cloudsea (disableVisualization).
const MANIFEST_URL = 'textures/cloudsea.json';

let _assets = null;
let _promise = null;

function loadTexture(url, data) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) {
      // the masks and the flow are data: no colour space; linear filtering
      // keeps the build's softened edges
      t.colorSpace = data ? THREE.NoColorSpace : THREE.SRGBColorSpace;
      t.generateMipmaps = false;
      t.minFilter = THREE.LinearFilter;
      t.magFilter = THREE.LinearFilter;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.needsUpdate = true;
      resolve(t);
    }, undefined, function () { reject(new Error(url + ' failed to load')); });
  });
}

export function preloadCloudsea() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('cloudsea.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      if (!m.dawn || !m.dawnPlate || !m.masks || !m.flow) throw new Error('cloudsea.json incomplete (run tools/build-cloudsea.mjs)');
      const T = (f, data) => loadTexture('textures/' + f, data);
      const core = Promise.all([T(m.dawn), T(m.dawnPlate), T(m.masks, true), T(m.flow, true)]);
      // the sunrise is optional: a failure there keeps the dawn
      const rise = m.rise && m.risePlate && m.sun
        ? Promise.all([T(m.rise), T(m.risePlate)]).catch(function (err) { console.warn('[party-mode] cloudsea sunrise unavailable, dawn only', err); return null; })
        : Promise.resolve(null);
      return Promise.all([core, rise]).then(function (parts) {
        const c = parts[0], r = parts[1];
        _assets = { manifest: m, dawn: c[0], dawnPlate: c[1], masks: c[2], flow: c[3], rise: r ? r[0] : null, risePlate: r ? r[1] : null };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] cloudsea assets unavailable, Cloudsea will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getCloudsea() {
  return _assets;
}
